import React from 'react';
import Icon from './AppIcon';

const SiteFooter = () => {
  const currentYear = new Date()?.getFullYear();
  return (
    <footer className="bg-card mt-16 border-t border-border">
      <div className="mx-auto max-w-[960px] px-4 py-8 sm:px-6 lg:px-8">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary/10">
                <img src="/assets/images/logo.png" alt="SNEAKER CARE 로고" className="h-6 w-6 object-contain" />
              </div>
              <span className="text-lg font-extrabold text-foreground" style={{ fontFamily: "'Baloo 2', cursive" }}>SNEAKER CARE</span>
            </div>
            <p className="text-sm text-muted-foreground">
              전문가의 손길로 당신의 스니커즈를 새것처럼 관리합니다.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-foreground mb-3">서비스</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>베이직 케어</li>
              <li>스탠다드 케어</li>
              <li>픽업/배송 서비스</li>
              <li>카카오톡 알림</li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-foreground mb-3">고객 지원</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>자주 묻는 질문</li>
              <li>이용 약관</li>
              <li>개인정보 처리방침</li>
              <li>환불 정책</li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-foreground mb-3">연락처</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li className="flex items-center gap-2">
                <Icon name="Phone" size={16} />
                <span>010-4681-6862</span>
              </li>
              <li className="flex items-center gap-2">
                <Icon name="Clock" size={16} />
                <span>평일 09:00-18:00</span>
              </li>
              <li className="flex items-center gap-2">
                <Icon name="Clock" size={16} />
                <span>점심 시간 12:00 - 13:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            &copy; {currentYear} SNEAKER CARE. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://www.instagram.com/sneakercare_kr/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-foreground transition-colors"
              aria-label="인스타그램"
            >
              <Icon name="Instagram" size={20} />
            </a>
            <a
              href="https://pf.kakao.com/_IRxoxmn"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-foreground transition-colors"
              aria-label="카카오톡 채널"
            >
              <Icon name="MessageCircle" size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
